import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
import { isMobile } from "react-device-detect";
const DefaultIcon = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;
function LocationMap({ lat, lng, amusementName }) {
  // مختصات مرز ایران
  //   const iranBounds = [
  //     [24.0, 44.0], // جنوب غرب
  //     [40.0, 63.5], // شمال شرق
  //   ];
  return (
    <MapContainer
      center={[lat, lng]}
      zoom={15}
      scrollWheelZoom={true}
      style={{ height: isMobile ? "250px" : "300px", width: "100%" }}
      //   maxBounds={iranBounds} // محدودیت نقشه
      //   maxBoundsViscosity={1.0} // اجازه خروج نمیده
      className="rounded-3"
      attributionControl={false}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution=""
      />

      <Marker position={[lat, lng]}>
        <Popup>موقعیت {amusementName}</Popup>
      </Marker>
    </MapContainer>
  );
}

export default LocationMap;
